// IE Hub - Document Constants
// Shared configuration for document filtering

export const ALLOWED_ENTRY_SOURCES = [
  "empsupportallowancestatutory",
  "jobSeekerAllowance",
  "incomeSupport",
];

/**
 * Returns true if a document with the given entrySource should be shown in the main list.
 * A document with no entrySource is always shown in the main list.
 */
export const isAllowedEntrySource = (entrySource?: string | null): boolean => {
  if (!entrySource) return true;
  return ALLOWED_ENTRY_SOURCES.includes(entrySource);
};
